import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { ArrowUpRight } from 'lucide-react';
import { caseStudies } from '../mockData';

const CaseStudies = () => {
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <section id="case-studies" className="relative bg-black py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-blue-950/10 to-black" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Case <span className="text-gray-500">Studies</span>
          </h2>
          <p className="text-gray-400 text-lg mx-auto leading-relaxed">
            Risultati riscontrabili, impatto misurabile. I rapporti di collaborazione con Brand e Creator 
            sono spesso disciplinati da accordi di riservatezza e non divulgazione, questa la ragione per cui 
            in questa sezione viene fatto genericamente riferimento al Settore e ai KPIs che, estrapolati e 
            proposti mantenendo l'anonimato, chiariscono la consistenza del nostro lavoro. Per questa ragione 
            siamo soliti proporre un primo periodo di prova, libero da vincoli contrattuali, clausole o 
            implicazioni di sorta, per dar prova dei risultati che siamo in grado di ottenere attraverso il 
            nostro contributo prima di procedere con una eventuale formalizzazione a medio o lungo termine.
          </p>
        </div>

        {/* Case Studies Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {caseStudies.map((study) => (
            <div
              key={study.id}
              className="group cursor-default"
              onMouseEnter={() => setHoveredId(study.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <Card className="h-full bg-black border-white/10 hover:border-blue-500/50 transition-all duration-500 overflow-hidden rounded-2xl">
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={study.image}
                    alt={study.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                  
                  {/* Number Overlay */}
                  <div className="absolute top-4 left-4 text-white/20 text-6xl font-bold">
                    {String(study.id).padStart(2, '0')}
                  </div>

                  {/* Arrow Icon */}
                  <div className="absolute top-4 right-4">
                    <div className={`w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center transition-all duration-300 ${
                      hoveredId === study.id ? 'bg-blue-500' : ''
                    }`}>
                      <ArrowUpRight className="h-5 w-5 text-white" />
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6 space-y-4">
                  {/* Title */}
                  <h3 className="text-2xl font-bold text-white group-hover:text-blue-400 transition-colors duration-300">
                    {study.title}
                  </h3>

                  {/* Category */}
                  <div className="text-sm text-gray-500">
                    {study.category}
                  </div>

                  {/* Tags */}
                  <div className="flex flex-wrap gap-2">
                    {study.tags.map((tag, idx) => (
                      <Badge
                        key={idx}
                        variant="outline"
                        className="text-xs border-white/20 text-gray-400 hover:border-blue-500/50 hover:text-blue-400 transition-colors"
                      >
                        {tag}
                      </Badge>
                    ))}
                  </div>

                  {/* Results */}
                  <div className="pt-4 border-t border-white/10">
                    <div className="text-sm text-gray-500 mb-1">Risultati</div>
                    <div className="text-lg font-semibold text-blue-400">
                      {study.results}
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;